import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=67ff32a9&scoped=true"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"
import style0 from "./BasePageTitle.vue?vue&type=style&index=0&id=67ff32a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff32a9",
  null
  
)

export default component.exports